import { BasketItem } from '@df/session/api/basket/basket-item';

declare module '@df/session/api/basket/basket-item' {
    interface BasketItem {
        isGiftCard?: boolean;
    }
}
export class GiftcardsBasketItem extends BasketItem {
    /**
     * If item is giftcard
     */
    override readonly isGiftCard = true;

    override qtyEditable = false;

    override get url(): string {
        return this.product?.parent.data?.url || '';
    }
}
